// @ts-check
import { defineStore } from "pinia";

export const useDataPrivacy = defineStore("dataPrivacy", {
  state: () => ({
    items: [],
    pagination: null,
    loading: false,
  }),
});
